import { Logger, ArrayUtils } from "neo-common";
import {
    ICheckOptions,
    IReelTeasingAttributes,
    ISymbolTeasingAttributes,
    ReelTeasingActions,
    SymbolTeasingActions,
    TeasingComponentAbstract,
} from "./TeasingComponentAbstract";
import {
    Configuration,
    GeneralConfigurationAttributes,
    MachineConfigurationAttributes,
} from "../Components/Configuration";
import { Settings } from "./Settings";
import { PlayList } from "../Components/Sounds/PlayList";

/**
 * @author Marek Turkovic
 */
export class TeasingExtended extends TeasingComponentAbstract {
    constructor() {
        super();

        // default values
        this.reelCount = 5;
        this.teasingStopDelay = 90;
        this.minimumSymbolsForTeasing = 2;
        this.countSymbolsOnReelsAndRows = [0, 0];
        this.canPlayTeaserSound = false;
        this.wasPlayedTeaserSound = false;
        this.wasPlayedTeaserWinSound = false;
        this.wasPlayedTeaserFailSound = false;
        this.teasingSymbol = [12, 11];

        this.finishTeasing = this.finishTeasing.bind(this);

        // CONFIGS
        let configs: Array<string> = ["GeneralConfiguration", "MachineConfiguration"];
        for (let i = 0; i < configs.length; i++) {
            let config = Configuration.Configurations[configs[i]];
            if (config != null) {
                this.configurate(config);
            }
        }

        // REELS DEFAULT
        for (let i = 0; i < this.reelCount; i++) {
            this.reelsTeasingAttributes[i] = {
                action: ReelTeasingActions.DO_NOTHING,
                stopping: false,
                stopDelay: i * this.stopDelay,
            };
        }

        // SYMBOLS DEFAULT
        for (let i = 0; i < this.reelCount; i++) {
            if (this.symbolsTeasingAttributes[i] == null) {
                this.symbolsTeasingAttributes[i] = [];
            }
            for (let j = 0; j < this._visibleSymbolCount; j++) {
                this.symbolsTeasingAttributes[i][j] = { teasable: false, action: SymbolTeasingActions.NOWIN };
            }
        }

        this._customData = [];
    }

    set customData(value: any) {
        this._customData = value;
    }

    /**
     * Get attributes from configuration and set up supported properties.
     * @method configurate
     * @param node is Element from xml
     * @return void
     */
    protected configurate(node: Element): void {
        if (node.hasAttribute(GeneralConfigurationAttributes.REEL_COUNT)) {
            this.reelCount = parseInt(node.getAttribute(GeneralConfigurationAttributes.REEL_COUNT));
        }

        if (node.hasAttribute(GeneralConfigurationAttributes.VISIBLE_SYMBOL_COUNT)) {
            this._visibleSymbolCount = parseInt(node.getAttribute(GeneralConfigurationAttributes.VISIBLE_SYMBOL_COUNT));
        }

        if (node.hasAttribute(MachineConfigurationAttributes.TEASING_STOP_DELAY)) {
            this.teasingStopDelay = parseInt(node.getAttribute(MachineConfigurationAttributes.TEASING_STOP_DELAY));
        }

        if (node.hasAttribute(GeneralConfigurationAttributes.REEL_X)) {
            this.reelX = ArrayUtils.numberArray(node.getAttribute(GeneralConfigurationAttributes.REEL_X));
        }

        if (node.hasAttribute(GeneralConfigurationAttributes.REEL_Y)) {
            this.reelY = ArrayUtils.numberArray(node.getAttribute(GeneralConfigurationAttributes.REEL_Y));
        }

        if (node.hasAttribute(MachineConfigurationAttributes.STOP_DELAY)) {
            this.stopDelay = parseInt(node.getAttribute(MachineConfigurationAttributes.STOP_DELAY));
        }
    }

    public addElementInstance(element: Object): void {
        this.elementInstance[Object.keys(element)[0]] = element[Object.keys(element)[0]];
    }

    //******************************************************************************************************************
    //  CHECK REELS
    //******************************************************************************************************************

    /**
     * Check called before reel.spinStop(). Checks if teasing is possible and checks which reel can be stopped immediately.
     * @param {ICheckOptions} options
     */
    public checkOnInit(options: ICheckOptions): Array<IReelTeasingAttributes> {
        this.stoppedSymbolsArray = options.stoppedSymbols;
        this.force = options.force;
        let aditionalDelay: number;
        let counterFS = 0;
        let counterPM = 0;
        let stopDelay = 0;

        if (options.force) {
            this.teasingEnabled = false;
        } else {
            if (this.isEnoughtForStartTeasing(0, 2, 11) || this.isEnoughtForStartTeasing(2, 4, 12)) {
                this.teasingEnabled = true;
            } else {
                this.teasingEnabled = false;
            }
        }

        if (!this.teasingEnabled) {
            aditionalDelay = 0;
        } else {
            stopDelay = aditionalDelay = 160;
        }

        for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
            switch (reelIndex) {
                case 0:
                    this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.NORMAL;
                    this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay;
                    if (this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[1]) !== -1) {
                        counterFS++;
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.POSSIBLE;
                    }
                    // if(this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[1]) !== -1){
                    //     counterPM++;
                    //     this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.POSSIBLE;
                    // }
                    break;
                case 1:
                    this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.NORMAL;
                    this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay;
                    if (this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[1]) !== -1) {
                        counterFS++;
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.POSSIBLE;
                    }
                    // if(this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[1]) !== -1){
                    //     counterPM++;
                    //     this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.POSSIBLE;
                    // }
                    break;
                case 2:
                    if (counterFS >= 2) {
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.TEASE;
                    } else {
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.NORMAL;
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.POSSIBLE;
                    }

                    if (this.teasingEnabled && counterFS >= this.minimumSymbolsForTeasing) {
                        this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay + stopDelay;
                        // stopDelay += aditionalDelay
                    } else {
                        this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay;
                    }
                    // if(this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[0]) !== -1){
                    //     counterFS++;
                    // }
                    if (this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[0]) !== -1) {
                        counterPM++;
                    }
                    break;
                case 3:
                    if (counterPM >= 2) {
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.TEASE;
                    } else {
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.NORMAL;
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.POSSIBLE;
                    }

                    if (
                        this.teasingEnabled &&
                        (counterFS >= this.minimumSymbolsForTeasing || counterPM >= this.minimumSymbolsForTeasing)
                    ) {
                        this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay + stopDelay;
                    } else {
                        this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay;
                    }
                    // if(this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[0]) !== -1){
                    //     counterFS++;
                    // }
                    if (this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[0]) !== -1) {
                        counterPM++;
                        if (counterFS >= this.minimumSymbolsForTeasing && counterPM >= 2) {
                            stopDelay += aditionalDelay;
                        }
                    }

                    break;
                case 4:
                    if (counterPM >= 2) {
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.TEASE;
                    } else {
                        this.reelsTeasingAttributes[reelIndex].action = SymbolTeasingActions.NORMAL;
                    }
                    if (
                        this.teasingEnabled &&
                        (counterFS >= this.minimumSymbolsForTeasing || counterPM >= this.minimumSymbolsForTeasing)
                    ) {
                        this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay + stopDelay;
                        // stopDelay += aditionalDelay
                    } else {
                        this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay;
                    }
                    // if(this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[0]) !== -1){
                    //     counterFS++;
                    // }
                    // if(this.stoppedSymbolsArray[reelIndex].symbols.indexOf(this.teasingSymbol[1]) !== -1){
                    //     counterPM++;
                    // }
                    break;
            }
        }

        return this.reelsTeasingAttributes;
    }

    /**
     *
     * @param {number} reelIndexStart
     * @param {number} reelIndexStop
     * @returns {boolean}
     */
    protected isEnoughtForStartTeasing(reelIndexStart = 0, reelIndexStop: number, teasingSymbol?: number): boolean {
        return this.countSymbols(reelIndexStart, reelIndexStop, teasingSymbol) >= this.minimumSymbolsForTeasing;
    }

    /**
     * Count symbols of some kind on reels.
     * @param {number} reelIndexStart
     * @param {number} reelIndexStop
     * @param symbolId
     * @returns {number}
     */
    public countSymbols(reelIndexStart = 0, reelIndexStop: number, symbolId: number): number {
        let count = 0;

        for (let i = reelIndexStart; i <= reelIndexStop; i++) {
            if (this.stoppedSymbolsArray[i].symbols.indexOf(symbolId) !== -1) {
                count++;
            }
        }

        return count;
    }

    /**
     *
     * @param {number} reelIndexStart
     * @param {number} reelIndexStop
     * @param {number} symbolId
     * @returns {number}
     */
    protected getCountSymbolsOnReelsAndRows(reelIndexStart = 0, reelIndexStop: number): Array<number> {
        this.countSymbolsOnReelsAndRows = [0, 0];

        for (let i = reelIndexStart; i <= reelIndexStop; i++) {
            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                if (this.stoppedSymbolsArray[i].symbols[j]) {
                    if (this.stoppedSymbolsArray[i].symbols[j] === this.teasingSymbol[0]) {
                        this.countSymbolsOnReelsAndRows[0]++;
                    }
                    if (this.stoppedSymbolsArray[i].symbols[j] === this.teasingSymbol[1]) {
                        this.countSymbolsOnReelsAndRows[1]++;
                    }
                }
            }
        }

        return this.countSymbolsOnReelsAndRows;
    }

    /**
     *
     * @returns {number}
     */
    public getTeasingSymbol(): number {
        return this.teasingSymbol[0];
    }

    //******************************************************************************************************************
    //  CHECK SYMBOLS TEASING
    //******************************************************************************************************************

    /**
     *
     * @param {number} reelIndex
     * @returns {Array<ISymbolTeasingAttributes>}
     */
    public checkSymbolsPerReel(reelIndex: number): Array<Array<ISymbolTeasingAttributes>> {
        // if (this.teasingEnabled) {

        let countOfSymbol = this.getCountSymbolsOnReelsAndRows(0, reelIndex);
        /*
            0 - nowin
            1 - normal
            2 - impact
            3 - tease
            */
        switch (reelIndex) {
            case 0:
                for (let i = 0; i <= reelIndex; i++) {
                    for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                        // if (this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j])==0) {
                        //     this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                        // } else if (this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j])==1) {
                        //     this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                        // } else {
                        this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                        // }
                    }
                }
                break;
            case 1:
                if (countOfSymbol[1] > 1) {
                    for (let i = 0; i <= reelIndex; i++) {
                        for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                            if (this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j]) == 0) {
                                if (reelIndex === i) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                                } else {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.TEASE;
                                }
                            } else if (this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j]) == 1) {
                                if (reelIndex === i) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                                } else {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.TEASE;
                                }
                            } else {
                                this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NOWIN;
                            }
                        }
                    }
                } else {
                    for (let i = 0; i <= reelIndex; i++) {
                        for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                            if (this.stoppedSymbolsArray[i].symbols[j]) {
                                this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                            }
                        }
                    }
                }
                break;
            case 2:
                if (countOfSymbol[1] > 2) {
                    for (let i = 0; i <= reelIndex; i++) {
                        for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                            if (this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j]) == 0) {
                                if (reelIndex === i) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                                }
                            } else if (this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j]) == 1) {
                                if (reelIndex === i) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                                }
                            } else {
                                this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NOWIN;
                            }
                        }
                    }
                } else {
                    for (let i = 0; i <= reelIndex; i++) {
                        for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                            this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                            // if (this.stoppedSymbolsArray[i].symbols[j]) {
                            //     if (this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j])==0) {
                            //         if(reelIndex === i) {
                            //             this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                            //         }
                            //     } else {
                            //         this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                            //     }
                            // }
                        }
                    }
                }
                break;
            case 3:
                if (countOfSymbol[0] > 1) {
                    for (let i = 0; i <= reelIndex; i++) {
                        for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                            if (
                                this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j]) == 0 &&
                                countOfSymbol[0] > 1
                            ) {
                                if (reelIndex === i) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                                } else {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.TEASE;
                                }
                            } else {
                                this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NOWIN;
                            }
                        }
                    }
                } else {
                    for (let i = 0; i <= reelIndex; i++) {
                        for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                            if (this.stoppedSymbolsArray[i].symbols[j]) {
                                this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                            }
                        }
                    }
                }
                break;
            case 4:
                if (countOfSymbol[0] > 2) {
                    for (let i = 0; i <= reelIndex; i++) {
                        for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                            if (
                                this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j]) == 0 &&
                                countOfSymbol[0] > 2
                            ) {
                                if (reelIndex === i) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                                }
                            } else if (
                                this.teasingSymbol.indexOf(this.stoppedSymbolsArray[i].symbols[j]) == 1 &&
                                countOfSymbol[1] > 2
                            ) {
                                if (reelIndex === i) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT;
                                }
                            } else {
                                this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NOWIN;
                            }
                        }
                    }
                } else {
                    for (let i = 0; i <= reelIndex; i++) {
                        for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                            if (this.stoppedSymbolsArray[i].symbols[j]) {
                                this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                            }
                        }
                    }
                }
                break;
        }

        // } else {
        //     for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
        //         for (let j = 0; j < this.stoppedSymbolsArray[reelIndex].symbols.length; j++) {
        //             this.symbolsTeasingAttributes[reelIndex][j].action = SymbolTeasingActions.NORMAL;
        //         }
        //     }
        // }

        return this.symbolsTeasingAttributes;
    }

    //******************************************************************************************************************
    //  REELS TEASING ANIMATIONS
    //******************************************************************************************************************

    /**
     * Start animating teasing layers.
     *
     * @param reelIndex
     */
    public animateTeasing(reelIndex: number): void {
        if (this.teasingEnabled) {
            //this.removeTeasing(false);

            if (this.reelsTeasingAttributes[reelIndex + 1] != null) {
                if (this.reelsTeasingAttributes[reelIndex + 1].action === ReelTeasingActions.TEASE) {
                    if (!this.wasPlayedTeaserSound) {
                        //PlayList.play('SND_BaseFSTeaser');
                        this.wasPlayedTeaserSound = true;

                        // if (this.elementInstance['teasingReels'] != null) {
                        //     this.elementInstance['teasingReels'].goToCase('TEASING'+(reelindex+1));
                        // }
                    }
                } else if (this.reelsTeasingAttributes[reelIndex + 1].action === ReelTeasingActions.SPIN_STOP) {
                    this.removeTeasing(false);
                }
            }

            let countSymbolsOnReelsAndRows = this.getCountSymbolsOnReelsAndRows(0, reelIndex);
            let countSymbolsOnCurrentReel = this.getCountSymbolsOnReelsAndRows(reelIndex, reelIndex);

            if (countSymbolsOnCurrentReel[0]) {
                if (countSymbolsOnReelsAndRows[0] > 0 && countSymbolsOnReelsAndRows[0] < 2) {
                    //PlayList.play('SND_SymScatterStop01');
                } else if (countSymbolsOnReelsAndRows[0] >= 2) {
                    //PlayList.play('SND_SymScatterStop03');
                }
            }
        } else {
            this.removeTeasing(false);
        }
    }

    /**
     * Start animating teasing layers.
     *
     * @param reelIndex
     */
    public reelAnimationStart(reelIndex: number): void {
        if (this.elementInstance["teasingReel"] != null) {
            this.elementInstance["teasingReel"].alpha = 1;
            this.elementInstance["teasingReel"].visible = true;
            this.elementInstance["teasingReel"].x = this.reelX[reelIndex];
            this.elementInstance["teasingReel"].goToCase("INIT");
        }
    }

    /**
     *
     */
    public reelAnimationStop(): void {
        if (this.elementInstance["teasingReel"] != null) {
            if (
                this.elementInstance["teasingReel"].getCurrentCase() !== "NONE" &&
                this.elementInstance["teasingReel"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingReel"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingReel"].goToCase("OUTRO");
            }
        }
    }

    /**
     * Remove teasing animations.
     * In case of enought teasing symbols count win sound is played else fail sound is played.
     *
     * @param {boolean} noWin
     */
    public removeTeasing(noWin: boolean): void {
        if (noWin) {
            PlayList.play("SND_BaseFSTeaserFail");
        }

        if (this.wasPlayedTeaserSound) {
            //PlayList.stop('SND_BaseFSTeaser');

            if (
                this.countSymbolsOnReelsAndRows[1] > this.minimumSymbolsForTeasing ||
                this.countSymbolsOnReelsAndRows[0] > this.minimumSymbolsForTeasing
            ) {
                if (!this.wasPlayedTeaserWinSound) {
                    // PlayList.play('SND_BaseFSTeaserWin');
                    // PlayList.play('SND_BaseTeaserBonusWin');
                    // this.wasPlayedTeaserWinSound = true;
                }
            } else {
                if (!this.wasPlayedTeaserFailSound) {
                    // PlayList.play('SND_BaseFSTeaserFail');
                    // PlayList.play('SND_BaseTeaserBonusFail');
                    // this.wasPlayedTeaserFailSound = true;
                }
            }
            this.canPlayTeaserSound = false;
            this.wasPlayedTeaserSound = false;
        }
    }

    public finishTeasing(): void {
        this.canPlayTeaserSound = false;
        this.wasPlayedTeaserSound = false;
    }

    //******************************************************************************************************************
    //  LOG
    //******************************************************************************************************************

    /**
     * Trace to browser console.
     * @method log
     * @param s string
     * @return void
     */
    protected log(s: string): void {
        if (DEBUG) {
            let compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/TeasingExtended.ts
 **/